import { Component } from 'react';
import React from 'react';
import styled from "@emotion/styled";
import dimensions from 'styles/dimensions';
import { Inner } from 'styles/structure';
import colors from "styles/colors";
import Illustration from 'components/_ui/Illustration';

const HeroContainer = styled.div`
  padding: 4rem 0 8rem;
  background-color: ${colors.orange100};
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 6.4rem 0 8.8rem; 
  }
`;

const HeroInner = styled(Inner)`
  @media(min-width: ${dimensions.tabletLandscapeUp}px) { 
    display: flex;
    align-items: center;
  }
`;

const HeroImage = styled.div`
  display: block;
  width: 100%;
  max-width: 40rem;
  
  img {
    display: block;
    width: 100%;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 1 1 42rem;
    order: 2;
    margin-left: 5.6vw;
    max-width: none;
    
    img {
      &.is-mobile {
        display: none;
      }
    }
  }
`;

const HeroContent = styled.div`
  margin-top: 4rem;
  
  h3 {
    color: ${colors.teal800};
    
    & + * {
      margin-top: 2.4rem;
    }
  }
  
  em {
    position: absolute;
    font-style: normal;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transform: translateY(2rem);

    &.is-current {
      position: relative;
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
      transition: opacity 0.4s ease-in-out, transform 0.66s ease-out;
      
      &::after {
        transform: scaleX(1);
        transition: transform 0.4s ease-out;
      }
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -0.2rem;
      left: 0;
      width: 100%;
      height: 0.2rem;
      background-color: ${colors.teal800};
      transform: scaleX(0);
      transform-origin: center left;
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 0 01 57.6rem;
    max-width: 57.6rem;
    
    &:only-child {
      text-align: center;
      flex-basis: 100%;
      max-width: 74.8rem;
      margin: 0 auto;
      
      p {
        max-width: none;
      }
    }
    
    p {
      max-width: 90%;
    }
  }
`;

class CareersHero extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTerm: -1,
      timer: null,
      isPlaying: true,
    };
  }

  advanceTerm() {
    const newTerm = this.state.currentTerm < (this.props.terms.length - 1) ? (this.state.currentTerm + 1) : 0;

    this.setState({
      currentTerm: newTerm,
    })
  }

  componentDidMount() {
    if (this.props.terms.length > 1) {
      const timer = setInterval(() => {this.advanceTerm()}, this.props.duration);

      this.advanceTerm();

      this.setState({
        timer: timer,
        isPlaying: true,
      });
    } else {
      this.advanceTerm();
    }
  }

  render() {
    const current = this.state.currentTerm;
    const self = this;

    return (
      <HeroContainer>
        <HeroInner>
          {(self.props.illustration || self.props.image) && (
            <HeroImage>
              {self.props.illustration && (
                <>
                  <Illustration source={self.props.illustration} variant='hero' />
                  {self.props.image && <img className='is-mobile' src={self.props.image.url} alt={self.props.image.alt} loading="lazy" />}
                </>
              )}

              {(!self.props.illustration && self.props.image) && (
                <img src={self.props.image.url} alt={self.props.image.alt} loading="lazy" />
              )}

            </HeroImage>
          )}

          <HeroContent>
            <h3>
              <span>We are looking for the best </span>
              {self.props.terms.map((term, i) => (
                <em key={i} className={i === current ? 'is-current' : ''}>{term.text}</em>
              ))}
            </h3>
          </HeroContent>
        </HeroInner>
      </HeroContainer>
    );
  }
}

export default CareersHero;
